import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { fetchUserSubscriptionDetails } from '../../../../../../services/apiService';

const UserSubscription = ({ userId, courseType }) => {
  const [subscriptionInfo, setSubscriptionInfo] = useState({
    planType: '',
    paymentStage: '',
    orderId: '',
    cohortId: '',
    courseType: '',
    airmeetLink: '',
    firstPaymentDate: '',
    cohortName: '',
    paymentMode: '',
    userId: '',
    amount: '',
  });

  const getUserSubscriptionInfo = async () => {
    try {
      const response = await fetchUserSubscriptionDetails(userId, courseType);
      setSubscriptionInfo(response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserSubscriptionInfo();
  }, []);

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
        <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--heading-primary, #111827)', marginBottom: 12 }}>
          User Subscription Details
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>User Id:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.userId}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Course Type:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.courseType}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Cohort Name:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.cohortName}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Cohort Id:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.cohortId}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Plan Type:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.planType}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Order Id:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.orderId}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Payment Mode:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.paymentMode}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Payment Stage:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{subscriptionInfo?.paymentStage}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>First Payment Date:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
            {subscriptionInfo?.firstPaymentDate &&
              moment(subscriptionInfo?.firstPaymentDate).format('DD MMM YYYY')}
          </span>
        </div>
        {subscriptionInfo?.upgradedOn && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Upgraded On Date:</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
              {subscriptionInfo?.upgradedOn &&
                moment(subscriptionInfo?.upgradedOn).format('DD MMM YYYY')}
            </span>
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Amount:</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
            {subscriptionInfo?.amount &&
              (subscriptionInfo?.amount / 100).toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR',
              })}
          </span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Airmeet Link:</span>
          <a
            href={subscriptionInfo?.airmeetLink}
            target='_blank'
            rel='noreferrer'
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: 'var(--primary-main, #4F46E5)',
              wordBreak: 'break-all',
            }}
          >
            {subscriptionInfo?.airmeetLink}
          </a>
        </div>
    </div>
  );
};

export default UserSubscription;

